import React from 'react';
import {
  Feed,
} from 'semantic-ui-react';

import {
  formatDatetime,
} from '../../Utils';
import {
  SchoolLink,
} from '../../Links';

interface SchoolProps {
  id: string;
  name: string;
  country: string;
  city: string;
  lastVisit: string;
}

const School = ({
  id,
  name,
  country,
  city,
  lastVisit,
}: SchoolProps) => (
  <Feed.Event>
    <Feed.Content>
      <Feed.Summary>
        <Feed.User>
          <SchoolLink id={id}>
            {name}
          </SchoolLink>
        </Feed.User>
        <Feed.Date>
          上次留下足跡
          {' '}
          {formatDatetime(lastVisit)}
        </Feed.Date>
      </Feed.Summary>
      <Feed.Extra text>
        {country}
        {' '}
        {city}
      </Feed.Extra>
    </Feed.Content>
  </Feed.Event>
);

interface SchoolData extends SchoolProps {
  last_visit: string;
}

export default ({ data }: { data: SchoolData[] }) => (
  data.length > 0 ? (
    <Feed size="large">
      {data.map((school) => (
        <School
          city={school.city}
          country={school.country}
          id={school.id}
          key={school.id}
          lastVisit={school.last_visit}
          name={school.name}
        />
      ))}
    </Feed>
  ) : null
);
